export default function PHP_is_nan() {
  return (
    <div>
      <h1>PHP_is_nan</h1>
    </div>
  );
}
